import { render, staticRenderFns } from "./VoucherReport.vue?vue&type=template&id=6f2554fc"
import script from "./VoucherReport.vue?vue&type=script&lang=js"
export * from "./VoucherReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports